define('catalogTemplatesListView',[
  'module',
  'underscore',
  'app',
  'settings',
  'tableView',
  'tableDynamicTextFieldView',
  'tableHeaderFieldView',
  'tableFieldView',
  'buttonView',
  'bootbox',
  'modalView',
  'catalogTemplatesCreateView',
  'catalogEntities'
], function (
  Module,
  _,
  App,
  Settings,
  TableView,
  DynamicTextFieldView,
  HeaderFieldView,
  FieldView,
  ButtonView,
  bootbox,
  ModalView,
  CreateView
) {
  'use strict';

  var HeaderToolsView = HeaderFieldView.extend({
    className: 'catalog-templates-list-header-tools-view ' + HeaderFieldView.prototype.className,
    template: function(){ return '<div class="add-region"></div>'; },
    regions: { addRegion: '.add-region' },
    onRender: function(){
      var title = _.i18n('catalogs.templates.createNew') || 'New template';
      var btn = new ButtonView({ type: 'add', color: 'orange', text: title, title: title });
      this.addRegion.show(btn);
      btn.on('click', _.bind(function(){
      ModalView.prototype.open({
        childView: CreateView,
        title: title,
        confirmButtonText: _.i18n('common.create') || 'Create',
        onConfirm: _.bind(function(model){
          App.request('catalog.template:create', this.tableView.options.viewOptions.catalogSecId, model.toJSON())
          .done(_.bind(function(){
            this.tableView.reload();
            if (this.tableView.footerView && this.tableView.footerView.fetch) {
              this.tableView.footerView.fetch();
            }
          }, this))
          .fail(function(xhr){
            if (window && window.alert) {
              var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to create template';
              window.alert(msg);
            }
          });
        }, this),
        options: {
          catalogSecId: this.options.catalogSecId || (this.options.tableView && this.options.tableView.options && this.options.tableView.options.catalogSecId)
        }
      });
    }, this));
    }
  });

  // Row tools: delete template
  var RowToolsView = FieldView.extend({
    className: 'catalog-templates-list-row-tools-view ' + FieldView.prototype.className,
    template: function(){ return '<div class="tools-region"></div>'; },
    regions: { toolsRegion: '.tools-region' },
    onRender: function(){
        // Edit button
        var editBtn = new ButtonView({
          type: 'edit',
          text: _.i18n('common.edit') || 'Edit',
          color: 'lightgrey'
        });
        // Delete button
        var delBtn = new ButtonView({
          type: 'remove',
          text: _.i18n('common.delete'),
          color: 'red'
        });
        // Render buttons in order: Edit then Delete
        this.getRegion('toolsRegion').show(editBtn);
        this.getRegion('toolsRegion').$el.append(delBtn.render().el);

        // Edit click handler
        editBtn.on('click', _.bind(function(){
          var title = _.i18n('common.edit') || 'Edit';
          var confirmText = _.i18n('common.save') || 'Save';
          var catalogSecId = this.model.get('catalogSecId');
          var secId = this.model.get('secId');

          ModalView.prototype.open({
            childView: CreateView,
            title: title,
            confirmButtonText: confirmText,
            onConfirm: _.bind(function(viewModel){
              // viewModel is the model from CreateView with fields { content, type }
              return App.request('catalog.template:update', catalogSecId, secId, viewModel.toJSON())
                .done(_.bind(function(){
                  if (this.tableView) {
                    this.tableView.reload();
                    if (this.tableView.footerView && this.tableView.footerView.fetch) {
                      this.tableView.footerView.fetch();
                    }
                  }
                }, this))
                .fail(function(xhr){
                  if (window && window.alert) {
                    var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to update template';
                    window.alert(msg);
                  }
                });
            }, this),
            // Pass the existing model so the form is pre-filled
            model: this.model
          });
        }, this));

        // Delete click handler
        delBtn.on('click', _.bind(function(){
          bootbox.confirm(_.i18n('common.confirmDelete') || 'Are you sure?', _.bind(function(result){
            if(!result) return;
            var secId = this.model.get('secId');
            var catalogSecId = this.model.get('catalogSecId');
            App.request('catalog.template:delete', catalogSecId, secId)
              .done(_.bind(function(){
                if (this.tableView) {
                  this.tableView.reload();
                  if (this.tableView.footerView && this.tableView.footerView.fetch) {
                    this.tableView.footerView.fetch();
                  }
                }
              }, this))
              .fail(function(xhr){
                if (window && window.alert) {
                  var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to delete template';
                  window.alert(msg);
                }
              });
          }, this));
        }, this));
    }
  });

  Module.exports = TableView.extend({
    className: 'catalog-templates-list-view ' + TableView.prototype.className,
    pageSize: 50,
    pageMode: 'pagination',

    setFields: function(){
      var fields = [];

      fields.push({
        name: 'Content',
        label: _.i18n('common.content') || 'Content',
        className: 'content',
        view: DynamicTextFieldView,
        value: 'content',
        bind: 'content'
      });

      fields.push({ name: 'Type', label: _.i18n('common.type') || 'Type', className: 'type', bind: 'type' });

      fields.push({ name: 'Tools', className: 'tools', view: RowToolsView, headerView: HeaderToolsView });

      return fields;
    },

    fetch: function(first, pageSize){
      var defer = $.Deferred();
      App.request('catalog.templates:list', this.options.viewOptions.catalogSecId).done(_.bind(function(models){
        var slice = models.slice(first, first + pageSize);
        defer.resolve(slice);
      }, this));
      return defer.promise();
    },

    fetchCount: function(){
      var defer = $.Deferred();
      App.request('catalog.templates:list', this.options.viewOptions.catalogSecId).done(function(models){
        defer.resolve(models.length || 0);
      });
      return defer.promise();
    }
  });
});

